import { TableHeaderNamesConstants } from '../constants/table-header-names.constants';
import { SortingOrder } from '../../shared/models/table-sort.model';
import { ISortModel } from '../../shared/models/sort.model';
import { IProject } from '../../shared/models/project.model';

export const checkForContinueSorting = (a: ISortModel, b: ISortModel, key: TableHeaderNamesConstants) => {
  return (a[key] === null && b[key] === null || key === null);
};

export const checkIsNullValue = (value: string | boolean | number) => {
  return value === null ? '' : value;
};

export const performSorting = (a1, b1, sortOrder: SortingOrder): number => {

  a1 = checkIsNullValue(a1);
  b1 = checkIsNullValue(b1);

  return sortOrder ? b1.toString().localeCompare(a1.toString()) : a1.toString().localeCompare(b1.toString());
};

export function sortProjectsByKey<T> (projects: T[], key: TableHeaderNamesConstants, sortOrder: SortingOrder): T[] {
  return projects?.concat().sort((a: ISortModel, b: ISortModel) => {

    if (checkForContinueSorting(a, b, key)) {
      return;
    }

    if (isItSortByProjectOwner(key)) {
      return performSortingByProjectOwner((a as IProject), (b as IProject), sortOrder);
    }

    if (isItSortByDate(key)) {
      return performSortingByDate(a[key], b[key], sortOrder);
    }

    return performSorting(a[key], b[key], sortOrder);
  });
}

export const performSortingByDate = (a1, b1, sortOrder: SortingOrder): number => {
  a1 = checkIsNullValue(a1) || 0;
  b1 = checkIsNullValue(b1) || 0;

  return sortOrder ? compareDates(b1, a1) : compareDates(a1, b1);
}

export const performSortingByProjectOwner = (a: IProject, b: IProject, sortOrder: SortingOrder): number => {
  return performSorting((a as IProject)?.projectOwner?.firstName, (b as IProject)?.projectOwner?.firstName, sortOrder);
}

const compareDates = (date1: string, date2: string): number => {
  return new Date(date1).getTime() - new Date(date2).getTime()
}

export const isItSortByDate = (key: TableHeaderNamesConstants): boolean => {
  return (key === TableHeaderNamesConstants.LAST_MODIFIED || key === TableHeaderNamesConstants.CREATED);
}

export const isItSortByProjectOwner = (key: TableHeaderNamesConstants): boolean => {
  return key === TableHeaderNamesConstants.OWNER;
}

export function executeProjectsSort<T> (data: T[],
                                        key: TableHeaderNamesConstants,
                                        sortOrder: SortingOrder): T[] {
  if (!key || sortOrder === null) {
    return data;
  }

  return sortOrder !== SortingOrder.NONE ? sortProjectsByKey<T>(data, key, sortOrder) : sortByOriginalSequence<T>(data);
}

export function sortByOriginalSequence<T> (data: T[]): T[] {
  if(!data){
    return;
  }

  return data?.sort((a: ISortModel, b: ISortModel) => a.originalSequence - b.originalSequence);
}
